document.addEventListener("shown.bs.modal", function() {
  document.body.classList.add("modal-open");
});

document.addEventListener("hidden.bs.modal", function() {
  document.body.classList.remove("modal-open");
});

document.addEventListener("submit", function(event) {
  var form = event.target;
  var message;

  if (!form || !form.matches || !form.matches("form[data-confirm-message]")) {
    return;
  }

  message = form.getAttribute("data-confirm-message");

  if (!message) {
    return;
  }

  if (!window.confirm(message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

export function sccGetModalInstance(modal) {
  if (!modal) {
    return null;
  }

  if (!(modal.getAttribute("data-vue-component") || modal.querySelector("[data-vue-component]"))) {
    return null;
  }

  if (!modal.__sccModalInstance) {
    modal.__sccModalInstance = {
      show: function() {
        sccShowModal(modal);
      },
      hide: function() {
        sccHideModal(modal);
      },
      dispose: function() {
        delete modal.__sccModalInstance;
      }
    };
  }
  return modal.__sccModalInstance;
}

export function sccShowModal(modal) {
  if (!modal) {
    return;
  }

  if (window.sccDialogRegistry && modal.id && window.sccDialogRegistry[modal.id]) {
    window.sccDialogRegistry[modal.id].open();
    return;
  }

  modal.dispatchEvent(new CustomEvent("scc:modal:open"));
}

export function sccHideModal(modal) {
  if (!modal) {
    return;
  }

  if (window.sccDialogRegistry && modal.id && window.sccDialogRegistry[modal.id]) {
    window.sccDialogRegistry[modal.id].close();
    return;
  }

  modal.dispatchEvent(new CustomEvent("scc:modal:close"));
}

window.sccGetModalInstance = sccGetModalInstance;
window.sccShowModal = sccShowModal;
window.sccHideModal = sccHideModal;
